import React from "react";
import ColorInit from "../helper/ColorInit";
import Wishlist from "../components/Wishlist";

const ProductDetailsPageOne = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      <Wishlist />
    </>
  );
};

export default ProductDetailsPageOne;
